module.exports = __webpack_public_path__ + "img/chevron-left.573aff5.svg";